import React from 'react'

const IconAddColumn = ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="M164.04-755.96v551.92h249.54v-551.92H164.04Zm-55.96 607.88v-663.84h663.84v140.19h-55.96v-84.23H469.54v551.92h246.42v-84.42h55.96v140.38H108.08ZM469.54-480Zm-55.96 0h55.96-55.96Zm0 0Zm302.38 107.88v-80h-80v-55.96h80v-80h55.96v80h80v55.96h-80v80h-55.96Z"/>
   </svg>
  )
}
export default IconAddColumn 